const appStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  };
  
  const NotFound = () => {
  
    return (
      <div style={appStyle}>
        Page Not Found
      </div>
    );
  };
  
  export default NotFound;
  